import React from "react";
import t from "../../../../i18n";
import type { Period } from "@ui/Highcharts/hooks/usePeriod";
import testSerieData from "@ui/Highcharts/lib/testSerieData";
import Marker from "@ui/Highcharts/ui/Marker";
import { PointSymbol } from "@ui/Highcharts/ui/PointSymbol";
import { EXPECTED_SERIE_ID } from "../../Symptoms/Amplitude/getSeries";
import seriesColors from "../series/seriesColors";

interface P {
  series: (
    | Highcharts.SeriesLineOptions
    | Highcharts.SeriesFlagsOptions
    | Highcharts.SeriesArearangeOptions
    | Highcharts.SeriesScatterOptions
  )[];
  period: Period;
}

function ExpectedLegend({ series, period }: P) {
  const serie = series.find(s => s.id === EXPECTED_SERIE_ID);
  if (!serie || !testSerieData(serie, period, p => p.y !== null)) return null;

  return (
    <Marker
      name={t("symptoms.chart.legend.expected.name")}
      description={t("symptoms.chart.legend.expected.description")}
    >
      <PointSymbol height={9} width={9} color={seriesColors.expected} />
    </Marker>
  );
}

export default React.memo(ExpectedLegend);
